import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row items-center no-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "s-pr-xl"
}
const _hoisted_3 = { class: "s-profile--label" }
const _hoisted_4 = { class: "s-profile--caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_s_icon = _resolveComponent("s-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_btn_dropdown, {
    flat: "",
    "no-caps": "",
    class: _normalizeClass(["s-profile", { 's-profile--dense': _ctx.isMobile }]),
    "content-class": "s-profile__menu",
    "menu-anchor": "bottom end",
    "dropdown-icon": "app:arrow-light-bottom"
  }, {
    label: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isDesktop || _ctx.isLaptop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.profileLabel), 1),
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.cropText(_ctx.currentProfileType, 30)) + " " + _toDisplayString(_ctx.profileRole) + " ", 1),
                (_ctx.currentProfileType.length >= 30)
                  ? (_openBlock(), _createBlock(_component_q_tooltip, {
                      key: 0,
                      "content-class": "s-tooltip",
                      delay: _ctx.DELAY_TOOLTIP
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.currentProfileType), 1)
                      ]),
                      _: 1
                    }, 8, ["delay"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_s_icon, {
          class: "s-profile--icon",
          left: "",
          name: "app:user-mini"
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_q_list, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkList, (item, index) => {
            return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
              key: index,
              clickable: "",
              onClick: ($event: any) => (_ctx.routeTo(item.route))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { avatar: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_s_icon, {
                      name: item.icon
                    }, null, 8, ["name"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_close_popup]
            ])
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}